import { TFunction } from 'i18next'

export interface TagTranslationInput {
  label: string
  groupId?: string | null
  tagTypeLabel?: string
}

const translateDietaryTag = (cleanLabel: string, t: TFunction): string => {
  const lowerValue = cleanLabel.toLowerCase()
  let key = lowerValue

  if (
    lowerValue.includes('gluten free') ||
    lowerValue === 'gluten free' ||
    lowerValue.includes('gluten')
  ) {
    key = 'cereals'
  } else if (
    lowerValue.includes('nut free') ||
    lowerValue === 'nut free' ||
    lowerValue.includes('nuts')
  ) {
    key = 'nuts'
  } else if (
    lowerValue.includes('dairy free') ||
    lowerValue === 'dairy free' ||
    lowerValue.includes('dairy')
  ) {
    key = 'milk'
  } else if (
    lowerValue.includes('sugar free') ||
    lowerValue.includes('no sugar') ||
    lowerValue.includes('refined sugar')
  ) {
    key = 'refined_sugar'
  } else if (lowerValue === 'halal') {
    key = 'halal'
  } else if (lowerValue === 'vegan') {
    key = 'vegan'
  } else if (lowerValue === 'vegetarian') {
    key = 'vegetarian'
  } else if (lowerValue === 'kosher') {
    key = 'kosher'
  } else if (lowerValue.includes('pescatarian') || lowerValue === 'fish') {
    key = 'fish'
  } else {
    key = lowerValue.replace(/\s+/g, '')
  }

  return t(`dietaries:${key}`, { defaultValue: cleanLabel })
}

const translateOccasionTag = (cleanLabel: string, t: TFunction): string => {
  const upperValue = cleanLabel.toUpperCase()

  if (upperValue === 'BREAKFAST' || upperValue === 'LUNCH' || upperValue === 'DINNER') {
    return t(`emma:occasions_${upperValue}`, { defaultValue: cleanLabel })
  }

  return cleanLabel
}

const translateCuisineTag = (cleanLabel: string, t: TFunction): string => {
  const lowerValue = cleanLabel.toLowerCase().replace(/\s+/g, '')
  return t(`marketplace:${lowerValue}`, { defaultValue: cleanLabel })
}

export const getTranslatedTagLabel = (tag: TagTranslationInput, t: TFunction): string => {
  const cleanLabel = tag.label?.replace(/ kitchen/i, '') || ''

  if (tag.groupId) {
    if (tag.groupId === '47') {
      return translateDietaryTag(cleanLabel, t)
    }

    if (tag.groupId === '1') {
      // Dietary tags
      return translateDietaryTag(cleanLabel, t)
    }

    if (tag.groupId === '3') {
      // Occasion tags
      return translateOccasionTag(cleanLabel, t)
    }

    if (tag.groupId === '4') {
      // Cuisine tags
      return translateCuisineTag(cleanLabel, t)
    }
  }

  // Handle filter tags with tagTypeLabel
  if (tag.tagTypeLabel) {
    if (tag.tagTypeLabel === 'Dietary') {
      return translateDietaryTag(cleanLabel, t)
    }

    if (tag.tagTypeLabel === 'Occasion') {
      return translateOccasionTag(cleanLabel, t)
    }

    if (tag.tagTypeLabel === 'Cuisine') {
      return translateCuisineTag(cleanLabel, t)
    }
  }

  return cleanLabel
}
